import {pick} from 'lodash';
import {useShallow} from 'zustand/react/shallow';

import DevIcon from '@/assets/images/icon-dev.svg?react';
import Button from '@/components/button';
import {ButtonProps} from '@/components/button/button';
import {WEB_CLICK_TRACKING_KEY} from '@/services/analytics/web-click-tracking-key';
import {useInspector} from '../hooks/use-inspector';

type Props = Omit<ButtonProps, 'onClick' | 'trackingKey' | 'trackingAs'>;

export const DevInspectorToggle = (props: Props) => {
  const {isVisible, setVisible} = useInspector(useShallow(state => pick(state, ['isVisible', 'setVisible'])));

  const toggle = () => setVisible(!isVisible);

  return (
    <Button
      icon={!isVisible ? <DevIcon className="size-6 fill-white" /> : <div className="text-2xl">⛌</div>}
      onClick={toggle}
      trackingKey={WEB_CLICK_TRACKING_KEY.DISABLED}
      {...props}
    />
  );
};
